import { Component, OnInit, OnChanges, trigger, state, style, transition, animate, Input, EventEmitter, Output } from '@angular/core';

import { ItemMenuLateral } from './item-menu-lateral.model';

@Component({
  selector: 'menu-lateral',
  templateUrl: './menu-lateral.component.html',
  styleUrls: ['./menu-lateral.component.scss'],
  animations: [
    trigger('toggleHeight', [
      state('inactive', style({
        height: '0',
        opacity: '0',
        display: 'none'
      })),
      state('active', style({
        height: '*',
        opacity: '1',
        display: 'block'
      })),
      transition('inactive => active', animate('200ms ease-in')),
      transition('active => inactive', animate('200ms ease-out'))
    ]),
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(-100%, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ])
  ]
})
export class MenuLateralComponent implements OnInit {

  @Input('collapsed') isCollapsed: boolean = true;

  @Output() atualizaCollapsed = new EventEmitter();

  sidebarState: string = "in";

  toggleSidebar() {
    this.sidebarState = this.sidebarState === 'out' ? 'in' : 'out';
  }

  @Input('itensMenu') itensMenu: Array<ItemMenuLateral>;

  // Sub menu visibilities
  navigationSubState: any;

  navigationSuperClass: any;

  // Toggle sub menu
  toggleNavigationSub(menu, event) {
    event.preventDefault();
    this.navigationSubState[menu] = (this.navigationSubState[menu] === 'inactive' ? 'active' : 'inactive');
    this.navigationSuperClass[menu] = (this.navigationSubState[menu] === 'inactive' ? 'navigation__super-close' : 'navigation__super-open');
  }

  constructor() {

  }

  ngOnInit() {
    this.navigationSubState = {};
    this.navigationSuperClass = {};

    for (let item of this.itensMenu) {
      this.navigationSubState[item.nome] = 'inactive';
      this.navigationSuperClass[item.nome] = (item.subItens && item.subItens.length > 0) ? 'navigation__super-close' : '';
    }

    window.addEventListener('click', (e) => {
      if (!this.isCollapsed) {
        this.isCollapsed = true;
        this.atualizaCollapsed.emit();
      }
    }, false);
  }

  ngOnChanges() {

    if (this.isCollapsed) {
      this.sidebarState = 'in';
    } else {
      this.sidebarState = 'out';
    }
  }

  fechaColapse(){
    this.atualizaCollapsed.emit();

  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/menu-lateral/menu-lateral.component.ts